import TemplateContents from './TemplateContents';

export default class extends TemplateContents {
  init() {
    super.init();
  }

  reset() {
    super.reset();
  }

  destruct() {
    super.destruct();

    if (this.playBtn) this.playBtn.removeEventListener('click', this.bindPlayHandler);
    if (this.closeBtn) this.closeBtn.removeEventListener('click', this.bindCloseHandler);
    if (this.modal) this.modal.removeEventListener('click', this.bindOverlayClickHandler);
    document.removeEventListener('keydown', this.bindKeydownHandler);
  }

  setVars() {
    super.setVars();
  }

  setDom() {
    super.setDom();

    this.mv = document.querySelector('.tyre_techMV');
    this.playBtn = this.mv ? this.mv.querySelector('.tyre_techMV__playBtn') : null;
    this.modal = document.querySelector('.tyre_techModal');
    this.iframe = this.modal ? this.modal.querySelector('.tyre_techModal__iframe') : null;
    this.closeBtn = this.modal ? this.modal.querySelector('.tyre_techModal__close') : null;
  }

  initEvents() {
    super.initEvents();

    if (!this.playBtn || !this.modal || !this.iframe) return;

    this.bindPlayHandler = this.playHandler.bind(this);
    this.bindCloseHandler = this.closeHandler.bind(this);
    this.bindOverlayClickHandler = this.overlayClickHandler.bind(this);
    this.bindKeydownHandler = this.keydownHandler.bind(this);

    this.playBtn.addEventListener('click', this.bindPlayHandler);
    if (this.closeBtn) {
      this.closeBtn.addEventListener('click', this.bindCloseHandler);
    }
    this.modal.addEventListener('click', this.bindOverlayClickHandler);
  }

  start() {}

  playHandler() {
    // The iframe has no src until now — YouTube's own player loads on
    // demand, so there's nothing to preload ahead of the click.
    const videoId = this.iframe.dataset.youtubeId;
    this.iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&rel=0`;

    this.modal.classList.add('is-active');
    this.modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('lock');
    document.addEventListener('keydown', this.bindKeydownHandler);
  }

  closeHandler() {
    this.modal.classList.remove('is-active');
    this.modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('lock');
    document.removeEventListener('keydown', this.bindKeydownHandler);

    // Clearing src (rather than just hiding the modal) is what actually
    // stops YouTube playback — there's no cross-origin API call available
    // without loading the full IFrame Player API just for this.
    this.iframe.src = '';
  }

  keydownHandler(event) {
    if (event.key === 'Escape') this.closeHandler();
  }

  // Only the bare background counts as "outside" — this fires for every
  // click inside .tyre_techModal since it bubbles, so it must check the
  // click actually landed on the overlay itself, not on the iframe/close
  // button bubbling up through it.
  overlayClickHandler(event) {
    if (event.target === this.modal) this.closeHandler();
  }

  scrollHandler() {}

  enterframe() {}

  enterframeThinOut() {}

  executeResize() {
    super.executeResize();
  }
}
